import { decisionTypes } from '@/returns/components/OrderSelector/constants'

export const groupItemsByDecision = items => {
  const pending = []
  const discarded = []
  const byOrderObj = {}

  items.forEach(item => {
    if (!item.decision) {
      pending.push(item)
      return
    }

    if (item.decision.type === decisionTypes.discard) {
      discarded.push(item)
      return
    }

    if (item.decision.type === decisionTypes.link) {
      const { order } = item.decision
      if (!byOrderObj[order.id]) {
        byOrderObj[order.id] = { order, items: [] }
      }
      byOrderObj[order.id].items.push(item)
    }
  })

  return { pending, discarded, byOrder: Object.values(byOrderObj) }
}
